/* eslint-disable import/no-anonymous-default-export */
import { KEY_STORE_USER } from "../constants/env";
import { ICurrentUser } from "../interfaces/Core/Authentication/currentUser";

class LocalStorageService {
  setLocalUserStorage = (user: ICurrentUser) => {
    localStorage.setItem(KEY_STORE_USER, JSON.stringify(user));
  };

  getLocalUserStorage = (): ICurrentUser | null => {
    const localUser = localStorage.getItem(KEY_STORE_USER);
    const currentUser = localUser
      ? (JSON.parse(localUser) as ICurrentUser)
      : null;

    return currentUser;
  };

  removeLocalStorage = () => {
    localStorage.removeItem(KEY_STORE_USER);
  };
}
export default new LocalStorageService();
